"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescreteSelector = void 0;
/* eslint-disable eqeqeq */
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
require("./selector.scss");
const displayWrapper_1 = require("./common/displayWrapper");
const hooks_1 = require("common/hooks");
const selectorOption_1 = require("./common/selectorOption");
const slider_1 = require("./common/slider");
const react_hook_form_1 = require("react-hook-form");
const components_1 = require("utils/components");
const NormalSelector = ({ options, onChange, value, }) => {
    const convertedOptions = (0, react_1.useMemo)(() => options.map(({ title: label, value }) => ({
        value,
        label,
    })), [options]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.ConditionSelect, { options: convertedOptions, value: convertedOptions.find((option) => option.value == value) || {
                value: undefined,
            }, onChange: (option) => onChange(option === null || option === void 0 ? void 0 : option.value), hideSelectedOptions: false, blurInputOnSelect: false })));
};
const DescreteSelector = ({ options, onChange, value, uiType, hasError, noWrapList, noWrapText, showIconWithTitle, checkStyle, }) => {
    return (react_1.default.createElement("div", { style: {
            margin: "5px 0",
            whiteSpace: noWrapList ? "nowrap" : "normal",
            overflowX: "auto",
            paddingBottom: "5px",
        }, className: (0, classnames_1.default)({
            "has-error": hasError,
        }, uiType && `selector-${uiType}`) }, options.map(({ title, value: optionValue, icon, tooltip }, index) => (react_1.default.createElement("span", { key: index, className: (0, classnames_1.default)("selectorOption", 
        // eslint-disable-next-line eqeqeq
        optionValue == value && "active"), onClick: (e) => {
            var _a, _b;
            onChange(optionValue !== value ? optionValue : null);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
        }, onMouseDown: (e) => e.preventDefault(), "data-tooltip-id": "tooltip", "data-tooltip-content": tooltip, style: Object.assign(Object.assign({ marginRight: 10, whiteSpace: noWrapText ? "nowrap" : "normal" }, (icon ? { padding: "6px 10px" } : {})), (checkStyle && optionValue == value
            ? {
                backgroundColor: "#2D73B9",
                borderColor: "#2D73B9",
            }
            : !icon
                ? { padding: "6px 18px" }
                : {})) }, checkStyle && optionValue == value ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("i", { className: "mdi mdi-check bold" }),
        " ",
        title)) : icon ? (showIconWithTitle ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("i", { className: `mdi ${icon}` }),
        " ",
        title)) : (react_1.default.createElement("i", { className: `mdi ${icon}` }))) : (react_1.default.createElement("span", null, title)))))));
};
exports.DescreteSelector = DescreteSelector;
const SelectorSchemaComponent = (props) => {
    var _a;
    const { schema } = props;
    const { options, uiType, naValues, ignoreValues } = schema;
    const naTitles = (0, react_1.useMemo)(() => {
        return naValues === null || naValues === void 0 ? void 0 : naValues.map((naValue) => {
            var _a;
            return (_a = options.find((option) => option.value == naValue)) === null || _a === void 0 ? void 0 : _a.title;
        });
    }, [naValues, options]);
    const ignoreTitles = (0, react_1.useMemo)(() => {
        return ignoreValues === null || ignoreValues === void 0 ? void 0 : ignoreValues.map((ignoreValue) => {
            var _a;
            return (_a = options.find((option) => option.value == ignoreValue)) === null || _a === void 0 ? void 0 : _a.title;
        });
    }, [ignoreValues, options]);
    const convertedOptions = (0, selectorOption_1.useOptionIntl)(options);
    const convertedOptionsValidValues = (0, react_1.useMemo)(() => {
        return convertedOptions.filter((option) => {
            return (!(naValues === null || naValues === void 0 ? void 0 : naValues.find((naValue) => naValue == option.value)) &&
                !(ignoreValues === null || ignoreValues === void 0 ? void 0 : ignoreValues.find((ignoreValue) => ignoreValue == option.value)));
        });
    }, [convertedOptions, naValues, ignoreValues]);
    const { registerProps: { onChange }, value, fieldState, } = (0, core_1.useField)(props, [core_1.requiredValidator]);
    const sliderValue = (0, react_1.useMemo)(() => {
        const index = options.findIndex((option) => option.value == value);
        return index === -1 ? undefined : index;
    }, [options, value]);
    const sliderOnChange = (0, react_1.useCallback)((index) => {
        const option = index != null ? options[index] : undefined;
        onChange(option === null || option === void 0 ? void 0 : option.value);
    }, [onChange, options]);
    const s = (0, hooks_1.useStringIntl)();
    const NotApplicableComponent = (0, react_1.useMemo)(() => {
        return naValues || ignoreValues ? (react_1.default.createElement("div", { className: "number-selector-except" }, ignoreValues === null || ignoreValues === void 0 ? void 0 :
            ignoreValues.map((ignoreValue, index) => {
                var _a;
                const ignoreTitle = (_a = options.find((option) => option.value == ignoreValue)) === null || _a === void 0 ? void 0 : _a.title;
                return (react_1.default.createElement("span", { key: ignoreValue, className: (0, classnames_1.default)("numberSelectorOptionExcept", 
                    // eslint-disable-next-line eqeqeq
                    value != null && ignoreValue == value && "active"), onClick: (e) => {
                        var _a, _b;
                        // eslint-disable-next-line eqeqeq
                        onChange(ignoreValue != value ? ignoreValue : null);
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
                    }, onMouseDown: (e) => e.preventDefault() }, s(ignoreTitle)));
            }), naValues === null || naValues === void 0 ? void 0 :
            naValues.map((naValue, index) => {
                var _a;
                const naTitle = (_a = options.find((option) => option.value == naValue)) === null || _a === void 0 ? void 0 : _a.title;
                return (react_1.default.createElement("span", { key: naValue, className: (0, classnames_1.default)("numberSelectorOptionExcept", 
                    // eslint-disable-next-line eqeqeq
                    value != null && naValue == value && "active"), onClick: (e) => {
                        var _a, _b;
                        // eslint-disable-next-line eqeqeq
                        onChange(naValue != value ? naValue : null);
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
                    }, onMouseDown: (e) => e.preventDefault() }, s(naTitle)));
            }))) : (react_1.default.createElement(react_1.default.Fragment, null));
    }, [naValues, ignoreValues, value, onChange, s]);
    const handleOnChange = (value) => {
        var _a;
        onChange(value);
        (_a = schema.autoSaveHandler) === null || _a === void 0 ? void 0 : _a.call(schema);
    };
    const formContext = (0, react_hook_form_1.useFormContext)();
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState, loading: props.schema.showSpinner &&
            fieldState.isDirty &&
            ((_a = formContext === null || formContext === void 0 ? void 0 : formContext.formState) === null || _a === void 0 ? void 0 : _a.isSubmitting) },
        uiType === "normal" && (react_1.default.createElement(NormalSelector, { options: convertedOptions, value: value, onChange: onChange })),
        uiType === "slider" && (react_1.default.createElement(slider_1.Slider, { options: convertedOptionsValidValues, onChange: sliderOnChange, value: sliderValue, hasError: fieldState.invalid, showMiddleLabel: true, showLabelForSelectedValue: true, valueIncludeNA: value, naTitles: naTitles, naValues: naValues, ignoreTitles: ignoreTitles, ignoreValues: ignoreValues }, NotApplicableComponent)),
        uiType !== "normal" && uiType !== "slider" && (react_1.default.createElement(exports.DescreteSelector, { options: convertedOptions, value: value, onChange: handleOnChange, uiType: uiType, hasError: fieldState.invalid, noWrapList: schema.noWrapList, noWrapText: schema.noWrapText, showIconWithTitle: schema.showIconWithTitle, checkStyle: schema.checkStyle }))));
};
SelectorSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("SelectorDisplayComponent", (value, schema) => {
    const { options } = schema;
    const s = (0, hooks_1.useStringIntl)();
    // eslint-disable-next-line eqeqeq
    const selectedOption = options.find((option) => option.value == value);
    return selectedOption ? s(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.title) : "未設定";
});
exports.default = SelectorSchemaComponent;
